import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreService, URLUtils } from '@experian-digital/affordability-library';
import { STORE_FIELDS } from '@portal-store/models/store.model';
import { catchError, map, Observable, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppConfig } from '../models/app-config.interface';

const CONFIG_FILE = `assets/config/${environment.config}`;
export const SECOND = 1000;
@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  static config: AppConfig = {
    apiUrl: '',
    authUrl: '',
    oktaAuthUrl: '',
    instrumentationKey: '',
    clientId: '',
    oktaClientId: '',
    digitalIdentityUrl: '',
    employmentVerificationUrl: '',
    transactionsStatusRetryTimeoutInSeconds: '30',
    workReportCoverageCheckerUrl: '',
    sanctionsStatusRetryIntervalInSeconds: '5',
    sanctionsStatusRetryTimeoutInSeconds: '180',
    pepsAndSanctionsStatusRetryAttempts: '24',
    enablePendo: 'false',
    pendoApiKey: '',
  };

  constructor(
    private http: HttpClient,
    private store: StoreService,
  ) {}

  load(): Observable<boolean> | Observable<never> {
    return this.http.get(CONFIG_FILE).pipe(
      switchMap((config: AppConfig) => {
        if (
          !config?.transactionsStatusRetryTimeoutInSeconds ||
          !config?.apiUrl ||
          !config?.authUrl ||
          !config?.clientId
        ) {
          return throwError(() => new Error());
        }

        ApplicationConfigService.config.apiUrl = URLUtils.sanitizeUrl(config.apiUrl);
        ApplicationConfigService.config.digitalIdentityUrl = URLUtils.sanitizeUrl(config.digitalIdentityUrl);
        ApplicationConfigService.config.employmentVerificationUrl = URLUtils.sanitizeUrl(
          config.employmentVerificationUrl,
        );
        ApplicationConfigService.config.authUrl = URLUtils.sanitizeUrl(config.authUrl);
        ApplicationConfigService.config.instrumentationKey = URLUtils.sanitizeUrl(config.instrumentationKey);
        ApplicationConfigService.config.clientId = URLUtils.sanitizeUrl(config.clientId);
        ApplicationConfigService.config.transactionsStatusRetryTimeoutInSeconds = URLUtils.sanitizeUrl(
          config.transactionsStatusRetryTimeoutInSeconds,
        );
        ApplicationConfigService.config.workReportCoverageCheckerUrl = URLUtils.sanitizeUrl(
          config.workReportCoverageCheckerUrl,
        );
        ApplicationConfigService.config.pepsAndSanctionsStatusRetryAttempts = URLUtils.sanitizeUrl(
          config.pepsAndSanctionsStatusRetryAttempts,
        );
        ApplicationConfigService.config.oktaAuthUrl = URLUtils.sanitizeUrl(config.oktaAuthUrl);
        ApplicationConfigService.config.oktaClientId = URLUtils.sanitizeUrl(config.oktaClientId);
        ApplicationConfigService.config.enablePendo = config.enablePendo ?? 'false';
        ApplicationConfigService.config.pendoApiKey = config.pendoApiKey ?? '';
        return this.http.get(URLUtils.sanitizeUrl(ApplicationConfigService.config.apiUrl + '/api/features')).pipe(
          map((featureFlags) => {
            this.store.add(STORE_FIELDS.globalFeatures, featureFlags);
            return true;
          }),
        );
      }),
      catchError((_) =>
        throwError(() => new Error('Could not load configuration file or some of the configurations are not defined!')),
      ),
    );
  }
}
